module.exports = __webpack_public_path__ + "img/ch-secondary-res.6540e02e.jpg";